import React from 'react';
import { FormikContextType, FormikProvider } from 'formik';

interface FormProps {
  children: any,
  formik: FormikContextType<any>
}

const Form: React.FC<FormProps> = ({ children, formik }) => (
  <FormikProvider value={formik}>
    <form onSubmit={formik.handleSubmit}>
      {children}
    </form>
  </FormikProvider>
);

export default Form;
